import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import {
  oneClickUnsubscribeLinkFields,
  unsubscribeLinkFields,
} from "../common-fields";

/**
 * Marketing Agent schema for AI-generated email content.
 * This schema has no template variables except unsubscribe links
 * since the AI generates fully-formed content.
 */
export const marketingAgentSchema = defineSchema({
  fields: { ...unsubscribeLinkFields, ...oneClickUnsubscribeLinkFields },
});

export const exampleMarketingAgentSchemaInstance: SchemaInstance<
  typeof marketingAgentSchema
> = {
  unsubscribeLink: "https://example.com/unsubscribe",
  oneClickUnsubscribeLink: "https://example.com/one-click-unsubscribe",
};
